import { render, staticRenderFns } from "./promotion_popup.vue?vue&type=template&id=46f490e7&scoped=true&"
import script from "./promotion_popup.vue?vue&type=script&lang=js&"
export * from "./promotion_popup.vue?vue&type=script&lang=js&"
import style0 from "./promotion_popup.vue?vue&type=style&index=0&id=46f490e7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f490e7",
  null
  
)

export default component.exports